// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sobrescrever page-header para visualização */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}

.page-header h1 {
  flex: 1 1;
  min-width: 200px;
  margin: 0;
}

.chaves-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.search-filters-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 25px;
}

.search-box {
  position: relative;
  margin-bottom: 15px;
}

.search-input {
  width: 100%;
  padding: 12px 40px 12px 15px;
  font-size: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.clear-search {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: #e0e0e0;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.2s;
}

.clear-search:hover {
  background: #d0d0d0;
  color: #333;
}

.filters-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.filter-select {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 12px;
  font-size: 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.results-info {
  color: #666;
  font-size: 14px;
  padding: 10px 0;
  border-top: 1px solid #e0e0e0;
}

.results-info strong {
  color: #667eea;
  font-weight: 600;
}


.chave-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: transform 0.3s;
  position: relative;
  border: 3px solid transparent;
}

.chave-card.chave-finalizada {
  border-color: #38ef7d;
}

.chave-card.chave-em_andamento {
  border-color: #764ba2;
}

.chave-card.chave-nao_iniciada {
  border-color: #f5576c;
}

.chave-status-tag {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
}

.chave-nao_iniciada .chave-status-tag {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.chave-em_andamento .chave-status-tag {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.chave-finalizada .chave-status-tag {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
}

.chave-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.chave-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.chave-header h3 {
  margin: 0;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.chave-codigo {
  display: inline-block;
  background: rgba(255, 255, 255, 0.3);
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  border: 2px solid rgba(255, 255, 255, 0.5);
}

.chave-badge {
  background: rgba(255,255,255,0.2);
  padding: 5px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.chave-info {
  padding: 20px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  font-weight: 600;
  color: #666;
}

.info-row .value {
  font-weight: 500;
  color: #333;
}

.chave-actions {
  padding: 15px 20px;
  background: #f9f9f9;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-sm {
  padding: 8px 16px;
  font-size: 13px;
  flex: 1 1;
  min-width: 100px;
}

.chave-preview {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Header actions para botões de controle */
.header-actions {
  display: flex !important;
  gap: 10px !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  justify-content: flex-end !important;
  background: rgba(33, 150, 243, 0.05);
  padding: 8px 12px;
  border-radius: 8px;
  border: 2px solid rgba(33, 150, 243, 0.2);
}

.header-actions .btn {
  white-space: nowrap !important;
  min-width: 140px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

/* Banner de modo de edição */
.editing-mode-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 15px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilos para modo de edição */
.chave-preview.editing-mode .atleta:not(.bye) {
  -webkit-user-select: none;
          user-select: none;
}

.chave-preview .vencedor-selecionado {
  position: relative;
}

.chave-preview .vencedor-selecionado::after {
  content: '✓';
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: #27ae60;
  font-weight: bold;
  animation: checkPulse 0.5s ease-out;
}

@keyframes checkPulse {
  0% {
    transform: translateY(-50%) scale(0);
  }
  50% {
    transform: translateY(-50%) scale(1.3);
  }
  100% {
    transform: translateY(-50%) scale(1);
  }
}

/* Responsividade para ações do header */
@media (max-width: 768px) {
  .header-actions {
    flex-direction: column;
    width: 100%;
  }

  .header-actions button {
    width: 100%;
  }
  
  .chaves-grid {
    grid-template-columns: 1fr;
  }
  
  .filters-row {
    flex-direction: column;
  }
  
  .filter-select {
    min-width: 100%;
  }
  
  .chave-actions {
    flex-direction: column;
  }
  
  .btn-sm {
    width: 100%;
  }
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.status-badge.status-finalizada {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
}

.status-badge.status-andamento {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.status-badge.status-nao-iniciada {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

/* Modal de Senha */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

.password-modal {
  background: white;
  padding: 30px;
  border-radius: 12px;
  max-width: 450px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.password-modal h2 {
  margin-top: 0;
  color: #333;
  font-size: 24px;
}

.password-modal .form-group {
  margin-bottom: 0;
}

.password-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #555;
}

.password-modal .form-control {
  width: 100%;
  padding: 12px;
  font-size: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s;
}

.password-modal .form-control:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.password-modal .modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chaves.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;EACxB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAAoC;EACpC,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gCAAgC;AAChC;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* Sobrescrever page-header para visualização */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.page-header h1 {\n  flex: 1;\n  min-width: 200px;\n  margin: 0;\n}\n\n.chaves-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n.search-filters-container {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 25px;\n}\n\n.search-box {\n  position: relative;\n  margin-bottom: 15px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 40px 12px 15px;\n  font-size: 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  transition: all 0.3s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.clear-search {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #e0e0e0;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n  transition: all 0.2s;\n}\n\n.clear-search:hover {\n  background: #d0d0d0;\n  color: #333;\n}\n\n.filters-row {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 15px;\n}\n\n.filter-select {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px 12px;\n  font-size: 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.results-info {\n  color: #666;\n  font-size: 14px;\n  padding: 10px 0;\n  border-top: 1px solid #e0e0e0;\n}\n\n.results-info strong {\n  color: #667eea;\n  font-weight: 600;\n}\n\n\n.chave-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow: hidden;\n  transition: transform 0.3s;\n  position: relative;\n  border: 3px solid transparent;\n}\n\n.chave-card.chave-finalizada {\n  border-color: #38ef7d;\n}\n\n.chave-card.chave-em_andamento {\n  border-color: #764ba2;\n}\n\n.chave-card.chave-nao_iniciada {\n  border-color: #f5576c;\n}\n\n.chave-status-tag {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  white-space: nowrap;\n}\n\n.chave-nao_iniciada .chave-status-tag {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n}\n\n.chave-em_andamento .chave-status-tag {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.chave-finalizada .chave-status-tag {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  color: white;\n}\n\n.chave-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.chave-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.chave-header h3 {\n  margin: 0;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chave-codigo {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.3);\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  border: 2px solid rgba(255, 255, 255, 0.5);\n}\n\n.chave-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 5px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.chave-info {\n  padding: 20px;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-row .label {\n  font-weight: 600;\n  color: #666;\n}\n\n.info-row .value {\n  font-weight: 500;\n  color: #333;\n}\n\n.chave-actions {\n  padding: 15px 20px;\n  background: #f9f9f9;\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.btn-sm {\n  padding: 8px 16px;\n  font-size: 13px;\n  flex: 1;\n  min-width: 100px;\n}\n\n.chave-preview {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n/* Header actions para botões de controle */\n.header-actions {\n  display: flex !important;\n  gap: 10px !important;\n  align-items: center !important;\n  flex-wrap: wrap !important;\n  justify-content: flex-end !important;\n  background: rgba(33, 150, 243, 0.05);\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 2px solid rgba(33, 150, 243, 0.2);\n}\n\n.header-actions .btn {\n  white-space: nowrap !important;\n  min-width: 140px !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n\n/* Banner de modo de edição */\n.editing-mode-banner {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 15px 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  font-size: 15px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Estilos para modo de edição */\n.chave-preview.editing-mode .atleta:not(.bye) {\n  user-select: none;\n}\n\n.chave-preview .vencedor-selecionado {\n  position: relative;\n}\n\n.chave-preview .vencedor-selecionado::after {\n  content: '✓';\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 24px;\n  color: #27ae60;\n  font-weight: bold;\n  animation: checkPulse 0.5s ease-out;\n}\n\n@keyframes checkPulse {\n  0% {\n    transform: translateY(-50%) scale(0);\n  }\n  50% {\n    transform: translateY(-50%) scale(1.3);\n  }\n  100% {\n    transform: translateY(-50%) scale(1);\n  }\n}\n\n/* Responsividade para ações do header */\n@media (max-width: 768px) {\n  .header-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .header-actions button {\n    width: 100%;\n  }\n  \n  .chaves-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .filters-row {\n    flex-direction: column;\n  }\n  \n  .filter-select {\n    min-width: 100%;\n  }\n  \n  .chave-actions {\n    flex-direction: column;\n  }\n  \n  .btn-sm {\n    width: 100%;\n  }\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.status-badge.status-finalizada {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  color: white;\n}\n\n.status-badge.status-andamento {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.status-badge.status-nao-iniciada {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n}\n\n/* Modal de Senha */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.3s ease;\n}\n\n.password-modal {\n  background: white;\n  padding: 30px;\n  border-radius: 12px;\n  max-width: 450px;\n  width: 90%;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease;\n}\n\n.password-modal h2 {\n  margin-top: 0;\n  color: #333;\n  font-size: 24px;\n}\n\n.password-modal .form-group {\n  margin-bottom: 0;\n}\n\n.password-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #555;\n}\n\n.password-modal .form-control {\n  width: 100%;\n  padding: 12px;\n  font-size: 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  transition: all 0.3s;\n}\n\n.password-modal .form-control:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.password-modal .modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
